export default __webpack_public_path__ + "static/media/default-carousel-img.d3403510.jpg";